import { Form, Input, Button, Row, Col } from "antd";
import rules from "@/config/rules";
import "../index.less";

const RetrievePasswordRender = ({
  submitLogin,
  requestRetrievePassword,
  sendCode,
  isShowCode,
  time,
}) => {
  const [form] = Form.useForm();

  return (
    <div className="retrieve-password-page text-center">
      <div className="topContent">
        <h1 className="text-white mb-0">找回密码</h1>
      </div>
      <div className="section-paw">
        <div className="container">
          <div className="content">
            <div className="retrievePwdForm bg-white mx-auto rounded-3">
              <Form
                name="form"
                form={form}
                onFinish={requestRetrievePassword}
                validateTrigger="onBlur"
                autoComplete="off"
                className="text-start"
              >
                <Form.Item
                  name="username"
                  className="require_item"
                  rules={[
                    { required: true, message: "请输入您的手机号!" },
                    {
                      pattern: new RegExp(rules.phone),
                      message: "手机号格式不正确，请重新输入",
                    },
                  ]}
                >
                  <Input placeholder="手机号" />
                </Form.Item>
                <Row>
                  <Col>
                    <Form.Item
                      name="code"
                      className="require_item"
                      rules={[{ required: true, message: "请输入您的验证码!" }]}
                    >
                      <Input placeholder="验证码" />
                    </Form.Item>
                  </Col>
                  <Col className="h-100">
                    <Button
                      type="primary"
                      ghost
                      className="code"
                      onClick={() => sendCode(form.getFieldValue("username"))}
                      disabled={isShowCode ? true : false}
                    >
                      {isShowCode ? `${time}秒后重试` : "获取验证码"}
                    </Button>
                  </Col>
                </Row>
                <Form.Item className="text-center mb-0 pb-0">
                  <Button
                    className="ant-btn ant-btn-primary ant-btn-lg submitButton fs-5 fw-bold"
                    htmlType="submit"
                    loading={submitLogin}
                  >
                    下一步
                  </Button>
                </Form.Item>
              </Form>
              <p className="mt-4 mb-0">
                如果是邮箱用户，请
                <a
                  target="_brank"
                  className="text-decoration-underline"
                  href="https://chatlink.mstatik.com/widget/standalone.html?eid=a8c61b736c8292115778450893d6eaea"
                >
                  联系客服
                </a>
                重置密码！
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetrievePasswordRender;
